import React from "react";

export const DragVertical = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6.66667 12.6667C6.66667 13.4027 6.07 14 5.33333 14C4.59667 14 4 13.4027 4 12.6667C4 11.9307 4.59667 11.3333 5.33333 11.3333C6.07 11.3333 6.66667 11.9307 6.66667 12.6667ZM5.33333 6.66667C4.59667 6.66667 4 7.264 4 8C4 8.736 4.59667 9.33333 5.33333 9.33333C6.07 9.33333 6.66667 8.736 6.66667 8C6.66667 7.264 6.07 6.66667 5.33333 6.66667ZM5.33333 2C4.59667 2 4 2.59733 4 3.33333C4 4.06933 4.59667 4.66667 5.33333 4.66667C6.07 4.66667 6.66667 4.06933 6.66667 3.33333C6.66667 2.59733 6.07 2 5.33333 2ZM10.6667 11.3333C9.93 11.3333 9.33333 11.9307 9.33333 12.6667C9.33333 13.4027 9.93 14 10.6667 14C11.4033 14 12 13.4027 12 12.6667C12 11.9307 11.4033 11.3333 10.6667 11.3333ZM10.6667 6.66667C9.93 6.66667 9.33333 7.264 9.33333 8C9.33333 8.736 9.93 9.33333 10.6667 9.33333C11.4033 9.33333 12 8.736 12 8C12 7.264 11.4033 6.66667 10.6667 6.66667ZM10.6667 2C9.93 2 9.33333 2.59733 9.33333 3.33333C9.33333 4.06933 9.93 4.66667 10.6667 4.66667C11.4033 4.66667 12 4.06933 12 3.33333C12 2.59733 11.4033 2 10.6667 2Z" />
  </svg>
);
